import * as tslib_1 from "tslib";
import { workbenchApi } from "@cloudpivot/api";
import SetTimeTypeMixin from "@cloudpivot/flow-center/src/components/pc/common/index"; //公共处理模块
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import infos from './infosBm.vue';
// import pageHeader from './pageHeader.vue';
// import unfinishedList from './unfinishedList.vue';
let unComplete = class unComplete extends mixins(SetTimeTypeMixin) {
    // import pageHeader from './pageHeader.vue';
    // import unfinishedList from './unfinishedList.vue';
    constructor() {
        super(...arguments);
        this.infoData = {
            circulateItemCount: 0,
            toAdminItemCount: 0,
            workItemCount: 0,
            workflowCount: 0
        };
        // totalPage:number = 0;
        // currentPage:number = 0;
        // pageSize:number = 4;
        // list:any[] = [];
        // pageChange(type: 'prev' | 'next'){
        //   if(type === 'prev' && this.currentPage !== 0){
        //     this.currentPage = this.currentPage - 1
        //     this.getList();
        //   }else if(type === 'next' && this.currentPage !== this.totalPage - 1){
        //     this.currentPage = this.currentPage + 1
        //     this.getList();
        //   }
        // }
        this.todoNumber = 0;
    }
    refreshData() {
        this.getWorkCount();
        this.$refs.infos.getTodoNumber();
        this.todoNumber = this.$refs.infos.todoNumber;
    }
    getWorkCount() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workbenchApi.getWorkCount();
            if (res.errcode === 0) {
                this.infoData = res.data;
            }
        });
    }
    // refreshData(){
    //   this.currentPage = 0;
    //   this.getList()
    //   this.getWorkCount()
    //   this.$emit('closeIframeForm', 'unfinish')
    // }
    // async getList(){
    //   let res = await workbenchApi.searchWorkitems({
    //     wd: '',
    //     page: this.currentPage,
    //     size: this.pageSize
    //   })
    //   if(res.errcode === 0){
    //     res.data.content.forEach(item => {
    //       this.SetTimeType(item)
    //     });
    //     this.list = res.data.content;
    //     this.totalPage = res.data.totalPages;
    //   }
    // }
    created() {
        this.getWorkCount();
        // this.getList();
    }
};
unComplete = tslib_1.__decorate([
    Component({
        name: 'unComplete',
        components: {
            infos,
        }
    })
], unComplete);
export default unComplete;
